<template>
  <layout>
    <section>
      <div class="columns">
        <div class="column">
          <h1>{{ project.name }}</h1>
          <hr />
          <b-message
            type="is-success"
            v-if="isParticipant && isProvideFeedbackGivers.value == true"
          >
            You have been asked to provide your own feedback givers. Please use
            the button below to add some feedback givers to this project
            <br /><br />
            <inertia-link
              :href="
                route(
                  'feedback.project.provideFeedbackGiversIndex',
                  project.unique_id
                )
              "
            >
              <b-button type="is-primary">Invite</b-button>
            </inertia-link>
          </b-message>
          <div class="participants-list">
            <!-- if participant needs to give self feedback, this card is for them -->
            <div class="column is-half-desktop" v-if="isParticipant">
              <div class="participant-card card">
                <h2>
                  {{ $page.props.auth.user.first_name }}
                  {{ $page.props.auth.user.last_name }}
                </h2>
                <p class="email">{{ $page.props.auth.user.email }}</p>
                <p class="relationship">Self</p>
                <b-progress
                  type="is-success"
                  :value="selfProgress"
                  show-value
                  format="percent"
                ></b-progress>
                <inertia-link
                  :href="
                    route('feedback.project.questions', [
                      project.unique_id,
                      $page.props.auth.user.id,
                    ])
                  "
                >
                  <b-button type="is-primary">
                    <span v-if="selfProgress == 100"> Edit Feedback </span>
                    <span v-else> Provide Feedback </span>
                  </b-button>
                </inertia-link>
              </div>
            </div>

            <template v-if="participants">
              <div
                class="column is-half-desktop"
                v-for="participant in participants"
                :key="participant.unique_id"
              >
                <div class="participant-card card">
                  <h2>
                    {{ participant.first_name }} {{ participant.last_name }}
                  </h2>
                  <p class="email">{{ participant.email }}</p>
                  <p class="relationship">
                    {{ participant.relationship.name }}
                  </p>
                  <b-progress
                    type="is-success"
                    :value="participant.progress"
                    show-value
                    format="percent"
                  ></b-progress>
                  <inertia-link
                    :href="
                      route('feedback.project.questions', [
                        project.unique_id,
                        participant.unique_id,
                      ])
                    "
                  >
                    <b-button type="is-primary">
                      <span v-if="participant.progress == 100">
                        Edit Feedback
                      </span>
                      <span v-else> Provide Feedback </span>
                    </b-button>
                  </inertia-link>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </section>
  </layout>
</template>

<script>
import Layout from './Layout';

export default {
  components: {
    Layout,
  },
  props: {
    project: Object,
    isParticipant: Boolean,
    selfProgress: Number,
    participants: Array,
    isProvideFeedbackGivers: Object,
  },
};
</script>
